import cn from "@utils/cn";
import { Router, redirectTo, getIconProps } from "@utils";
import Icon from "@elements/Icon";

const CLASS_NAMES = cn(`
  flex
  items-center
  gap-3
  px-5
  py-3
  cursor-pointer

  hover:bg-black/20

  active:bg-black/30
`);

const LABEL_CLASS_NAMES = cn(`
  text-base
  font-medium
  select-none

  text-(--navbar-foreground-color)
`);

export default function DrawerLinkItem(props) {
  const {
    label,
    path,
    url,
    openInNewWindow,
    closeDrawer,
    isAdminOnly,
  } = props;

  const {
    text,
    icon,
  } = label;

  const iconProps = getIconProps(icon, {
    fixedWidth: true,
    color: "white",
  });

  const handleClick = () => {
    closeDrawer(false);

    const targetUrl = (path && Router.buildUrlFor(path)) || url;
    if (!targetUrl) return;

    if (openInNewWindow) {
      window.open(targetUrl, "_blank");
    } else {
      redirectTo(targetUrl);
    }
  };

  return (
    <div
      className={CLASS_NAMES}
      onClick={handleClick}
    >
      {icon && (
        <Icon {...iconProps} />
      )}

      <span className={LABEL_CLASS_NAMES}>
        {text}
        {isAdminOnly ? "*" : ""}
      </span>
    </div>
  );
}
